import React, { Component } from "react";
import { localStorageSetItem, localStorageGetItem } from "../../storage/index";
import ApiManager from "../../apiManager/index";

class LanguageList extends Component {
  changeLanguage(lngPrefix) {
    localStorageSetItem("defaultLngPrefix", lngPrefix);

    ApiManager.getTranslations().then(
      (resolve) => {
        this.props.setTranslationsAction(resolve.data);

        if (this.props.hasOwnProperty("updateAccount")) {
          this.props.updateAccount();
        }
      },
      (reject) => {
        console.log(reject);
      }
    );
  }

  classNameSetter() {
    let classNames = {
      mainBox: "main-wrapper__tab-languages-out tc",
      list: "tab tab--languages-list ver-top-box",
      listItem: "tab__item ver-top-box",
      button: "tab__link sprite-b db pr tl",
    };

    if (this.props.hasOwnProperty("classNames")) {
      classNames["mainBox"] = this.props.classNames.mainBox;
      classNames["list"] = this.props.classNames.list;
      classNames["listItem"] = this.props.classNames.listItem;
      classNames["button"] = this.props.classNames.button;
    }

    return classNames;
  }

  render() {
    let classNames = this.classNameSetter(),
      prefixes = ["hy", "ru", "en"],
      list = prefixes.map((item, index) => {
        return (
          <li className={classNames.listItem} key={index}>
            <button
              className={`${classNames.button} tab__link--${item} ${
                item === localStorageGetItem("defaultLngPrefix")
                  ? "tab__link--active"
                  : ""
              }`}
              type="button"
              onClick={() => {
                if (
                  !this.props.hasOwnProperty("classNames") &&
                  (window.innerWidth || window.screen.availWidth) < 1101
                ) {
                  item =
                    prefixes[index + 1 === prefixes.length ? 0 : index + 1];
                }
                this.changeLanguage(item);
              }}
            >
              {this.props.hasOwnProperty("lngText")
                ? this.props.lngText[item]
                : " "}
            </button>
          </li>
        );
      });

    return (
      <div className={classNames.mainBox}>
        <ul className={classNames.list}>{list}</ul>
      </div>
    );
  }
}

export default LanguageList;
